<template>
  <div class="container" v-loading.fullscreen.lock="loading">
    <div class="content-wrap" style="flex: 1 1 0%">
      <div class="main">
        <div class="lesson-video">
          <div class="lesson-video-title">
            {{ course.title }}
          </div>

          <div
            v-if="isLogin"
            style="height: 435px; position: relative; margin-top: 20px"
          >
            <div
              class="flex-center bg-black"
              v-if="courseLicense === null"
              :style="{
                position: 'absolute',
                left: 0,
                right: 0,
                'z-index': tipZIndex,
              }"
            >
              您未报名该课程，如需帮助请联系工作人员
            </div>
            <!-- 有权益 或 有免费试看课时 渲染player -->
            <div
              v-if="courseLicense || isFreeTrialLesson"
              class="player-olympic"
              :class="{ 'player-olympic-sm-screen': !fullScreen }"
              ref="player"
            >
              <!-- <Loading v-show="videoLoading" :color-list="loadingColor" /> -->
            </div>
          </div>
          <div v-else class="flex-center bg-black">
            您还未登录，请登录后观看
          </div>
        </div>
        <div class="lesson-catalogue">
          <div class="lesson-catalogue-header">
            <span>课程目录</span>
            <template v-if="isLogin">
              <span class="lesson-status" v-if="courseLicense === null">
                未授权
              </span>
            </template>
            <span
              v-else
              class="lesson-status"
              type="text"
              style="cursor: pointer"
              @click="$router.push('/login')"
            >
              点击登录后观看
            </span>
          </div>
          <div class="lesson-catalogue-scroll">
            <div class="lesson-catalogue-list">
              <div
                v-for="lesson in lessons"
                :key="lesson.id"
                :class="[
                  'lesson-catalogue-item',
                  playingVideo.id === lesson.id
                    ? 'lesson-catalogue-item--playing'
                    : '',
                ]"
              >
                <h3
                  class="lesson-catalogue-title"
                  @click="onLessonCatalogueClick(lesson)"
                >
                  <!-- 已登录用户，且有权益，不展示试看标签 -->
                  <template v-if="!(isLogin && courseLicense)">
                    <span
                      v-if="lesson.isFree === 1"
                      class="lesson-catalogue-item__is-free"
                    >
                      免费试看
                    </span>
                  </template>
                  {{ lesson.title }}
                </h3>
                <span v-if="lesson.isComplete" class="lesson-catalogue__tag">
                  已完成
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="detail">
        <div class="tabs">
          <div
            :class="['tab-item', activeTab === tab.value ? 'on' : '']"
            v-for="(tab, index) in tabs"
            :key="index"
            @click="onTabClick(tab)"
          >
            {{ tab.title }}
          </div>
        </div>

        <div class="content">
          <div
            class="content-intro ql-editor"
            v-if="activeTab === 'intro'"
            v-html="course.intro"
          ></div>
          <div
            class="content-work"
            v-else-if="
              activeTab === 'work' &&
              courseWorkConfig &&
              courseWorkConfig.isOpen === 1
            "
          >
            <template v-if="isLogin">
              <Work v-if="courseLicense" />
              <div v-else>您未报名该课程，如需帮助请联系工作人员</div>
            </template>
            <span v-else>您还未登录，请登录后查看</span>
          </div>
          <div
            class="study-progress"
            v-else-if="
              activeTab === 'studyProgress' &&
              courseCertificateConfig &&
              courseCertificateConfig.isOpen === 1
            "
          >
            <template v-if="isLogin">
              <StudyProgress
                :courseId="courseId"
                v-if="courseLicense"
              ></StudyProgress>
              <div v-else>您未报名该课程，如需帮助请联系工作人员</div>
            </template>
            <span v-else>您还未登录，请登录后查看</span>
          </div>
          <div
            class="certificate-template"
            v-else-if="
              activeTab === 'certificateTemplate' &&
              courseCertificateTemplateConfig &&
              courseCertificateTemplateConfig.isOpen === 1
            "
          >
            <div style="margin-bottom: 10px">
              <div
                v-if="courseCertificateTemplateConfig.intro"
                class="intro"
                v-html="courseCertificateTemplateConfig.intro"
              />
            </div>
            <el-image
              fit="cover"
              style="width: 650px; height: 400px"
              :src="courseCertificateTemplateConfig.templateImgUrl"
              :preview-src-list="[
                courseCertificateTemplateConfig.templateImgUrl,
              ]"
            />
          </div>
        </div>
      </div>
    </div>

    <InformationSupplementDialog
      ref="informationSupplementDialog"
      @success="onSuccess"
    />
  </div>
</template>

<script>
import { getCourseDetial, videoPlayStart, videoPlayEnd } from "@/api/course";
import Work from "./components/work.vue";
import StudyProgress from "./components/studyProgress";
import InformationSupplementDialog from "./components/InformationSupplementDialog.vue";

export default {
  name: "CourseDetail",
  components: {
    Work,
    StudyProgress,
    InformationSupplementDialog,
  },
  data() {
    return {
      course: {},
      courseLicense: null, // 权益
      courseCertificateTemplateConfig: null, // 证书模板
      courseWorkConfig: null, // 作业提交
      courseCertificateConfig: null, // 学习进度

      lessons: [],

      playingVideo: {},
      player: null,
      videoLoading: true,
      fullScreen: false,
      loading: false,

      tabs: [
        { title: "课程介绍", value: "intro" },
        // { title: "提交作业", value: "work" },
      ],
      activeTab: "intro",

      tipZIndex: 1001, // 控制视频提示框层级
    };
  },
  computed: {
    courseId({ $route }) {
      return $route.query.courseId;
    },
    isLogin() {
      return !!localStorage.getItem("TOKEN");
    },
    // 有免费试看
    isFreeTrialLesson({ lessons }) {
      return lessons.some((lesson) => lesson.isFree === 1);
    },
  },
  async mounted() {
    await this.getCourseDetial(this.courseId);

    if (this.isLogin) {
      if (this.courseLicense) {
        // 有权益
        this.createVideoPlayer(
          this.lessons[0].videoUrl,
          this.lessons[0].coverUrl
        );
        this.playingVideo = this.lessons[0];
      } else if (this.isFreeTrialLesson) {
        const video = this.lessons.find((lesson) => lesson.isFree === 1);
        // 有免费试看
        this.$nextTick(() => {
          this.createVideoPlayer(video.videoUrl, video.coverUrl);
        });
      }

      this.videoLoading = false;
    }
  },
  methods: {
    onTabClick(tab) {
      this.activeTab = tab.value;
    },
    async getCourseDetial() {
      this.loading = true;
      try {
        const { code, data } = await getCourseDetial(this.courseId);

        if (code === 500013) {
          this.$refs.informationSupplementDialog.show();

          return;
        }

        const {
          course,
          courseChapterList,
          courseLicense,
          courseWorkConfig,
          courseCertificateConfig,
          courseCertificateTemplateConfig,
        } = data;

        this.course = course;
        this.lessons = courseChapterList || [];
        this.courseLicense = courseLicense;

        // 按顺序push
        if (
          courseCertificateTemplateConfig &&
          courseCertificateTemplateConfig.isOpen === 1 &&
          this.tabs.every((item) => item.value !== "certificateTemplate")
        ) {
          this.tabs.push({ title: "证书模板", value: "certificateTemplate" });
        }
        if (
          courseWorkConfig &&
          courseWorkConfig.isOpen === 1 &&
          this.tabs.every((item) => item.value !== "work")
        ) {
          this.tabs.push({ title: "提交作业", value: "work" });
        }
        if (
          courseCertificateConfig &&
          courseCertificateConfig.isOpen === 1 &&
          this.tabs.every((item) => item.value !== "studyProgress")
        ) {
          this.tabs.push({ title: "学习进度", value: "studyProgress" });
        }

        this.courseCertificateTemplateConfig = courseCertificateTemplateConfig;
        this.courseWorkConfig = courseWorkConfig;
        this.courseCertificateConfig = courseCertificateConfig;
      } finally {
        this.loading = false;
      }
    },
    playVideo(video) {
      if (this.player === null || this.playingVideo.id === video.id) {
        return;
      }
      this.player.loadByUrl(video.videoUrl);
      this.playingVideo = video;
      this.player.play();
    },

    onLessonCatalogueClick(video) {
      if (!this.isLogin) {
        this.$router.push("/login");
        return;
      }

      // 免费试看
      if (video.isFree === 1) {
        if (this.player === null) {
          this.createVideoPlayer(video.videoUrl, video.coverUrl);
        }
        this.playVideo(video);

        return;
      } else if (video.isFree === 0 && this.courseLicense === null) {
        // 无免费试看，没有权益，显示提示
        this.tipZIndex = 1001;
        if (this.player !== null) {
          // 销毁
          this.player.dispose();
          this.player = null;
        }
        // 防止再次点击免费试看视频无效
        this.playingVideo = {};

        return;
      }

      // 没有权益
      if (this.courseLicense === null) return;

      this.playVideo(video);
    },
    createVideoPlayer(source, cover) {
      if (document.getElementById("player-con") === null) {
        let playerDomWrap = this.$refs.player;
        let playerDom = document.createElement("div");
        playerDom.setAttribute("id", "player-con");
        playerDomWrap.appendChild(playerDom);
      }

      const props = {
        id: "player-con",
        width: "100%",
        height: "435px",
        autoplay: false,
        language: "zh-cn",
        isLive: false,
        // definition: "FD,LD,SD,HD",
        clickPause: true,
        components: [],
      };

      if (source) {
        props.source = source;
      }

      if (cover) {
        props.cover = cover;
      }

      // eslint-disable-next-line no-undef
      this.player = new Aliplayer(props);
      this.player.on("requestFullScreen", this.fullScreenHandle);
      this.player.on("cancelFullScreen", this.cancelFullScreenHandel);
      this.player.on("ended", this.videoEnd);
      this.player.on("play", this.videoPlay);
    },
    videoEnd() {
      videoPlayEnd({
        courseId: this.courseId,
        courseChapterId: this.playingVideo.id,
      }).then(() => {
        this.getCourseDetial();
      });
    },
    videoPlay() {
      this.tipZIndex = -1;

      videoPlayStart({
        courseId: this.courseId,
        courseChapterId: this.playingVideo.id,
      });
    },
    fullScreenHandle() {
      let title = this.playingVideo.Title;
      this.player.getComponent("playerFullScreenTitle").fullScreenHandle(title);
      this.fullScreen = true;
    },
    cancelFullScreenHandel() {
      this.player
        .getComponent("playerFullScreenTitle")
        .cancelFullScreenHandle();
      this.fullScreen = false;
    },
    onSuccess() {
      this.getCourseDetial();
    },
  },
};
</script>

<style lang="scss" scoped>
.content-wrap {
  background: url("../../assets/detail-bg.png");
  overflow: hidden;
}

.main {
  display: flex;
  width: 1180px;
  height: 582px;
  margin: 0 auto;
  background: #0a2b51;
  border-radius: 20px;
  border: 1px solid #046bde;
  color: #fff;
  margin-top: 12px;
}

.lesson-video {
  box-sizing: border-box;
  width: 830px;
  padding: 30px;
  border-right: 1px solid #046bde;

  &-title {
    font-weight: 600;
    font-size: 22px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.lesson-status {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 26px;
  padding: 0 10px;
  background: #df8d46;
  border-radius: 13px;
  font-size: 14px;
  font-weight: 600;
}

.lesson-catalogue {
  flex: 1;
  box-sizing: border-box;
  padding: 30px;

  &-scroll {
    overflow-y: auto;
    height: 450px;
    margin: 20px;

    /* 设置滚动条的宽度 */
    &::-webkit-scrollbar {
      width: 6px; /* 或者您想要的任何宽度 */
    }

    /* 设置滚动条轨道（背景）的颜色 */
    &::-webkit-scrollbar-track {
      background: #eee; /* 滚动条背景色 */
      border-radius: 3px;
    }

    /* 设置滚动条滑块的颜色 */
    &::-webkit-scrollbar-thumb {
      background: #888; /* 滚动条滑块颜色 */
    }

    /* 当鼠标悬停在滚动条滑块上时，改变滑块颜色 */
    &::-webkit-scrollbar-thumb:hover {
      background: #555; /* 滚动条滑块悬停颜色 */
    }
  }

  &-header {
    display: flex;
    justify-content: space-between;
    align-items: center;

    span:first-child {
      font-size: 18px;
      font-weight: 600;
    }
  }

  //   &-list {
  //   }

  &-item {
    font-weight: 600;
    border-bottom: 1px solid #046bde;
    margin-bottom: 20px;
    padding-bottom: 20px;
    color: #aec8e7;

    &--playing {
      color: #fff;
    }

    &__is-free {
      display: inline-block;
      width: 56px;
      height: 20px;
      line-height: 20px;
      border-radius: 2px;
      font-size: 12px;
      background: #00b1a2;
      color: #fff;
      text-align: center;
    }
  }

  &-title {
    font-size: 16px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
  }

  &__tag {
    display: block;
    width: 46px;
    height: 20px;
    line-height: 20px;
    margin-left: auto;
    margin-top: 4px;
    background: #00b1a2;
    color: #fff;
    border-radius: 2px;
    font-size: 12px;
    text-align: center;
  }
}

::v-deep.player-olympic {
  height: 435px;
  background: #fff;
  position: relative;
  background-color: #373d41;

  .prism-progress-cursor {
    background-position: center center;
  }

  .az-loading {
    line-height: 485px;
  }

  .prism-player .prism-big-play-btn {
    top: 50% !important;
    left: 50% !important;
    margin-top: -32px;
    margin-left: -32px;
  }

  .prism-player .prism-fullscreen-btn {
    width: 38px;
    height: 38px;
    margin-top: 7px !important;
    margin-right: 15px !important;
  }

  .prism-player .prism-volume {
    margin-right: 15px !important;
  }

  .prism-player .prism-cc-btn {
    margin-right: 25px !important;
  }

  .prism-player .prism-setting-btn {
    margin-right: 25px !important;
  }

  .prism-player .prism-volume-control {
    left: auto !important;
    right: 165px;
  }

  &.player-olympic-sm-screen {
    .prism-player .prism-volume-control {
      left: auto !important;
      right: 125px;
    }

    .prism-player .prism-fullscreen-btn {
      margin-top: 15px !important;
      width: 24px;
      height: 24px;
    }

    .prism-player .prism-thumbnail {
      border: none;
    }

    .prism-player .prism-play-btn {
      width: 28px;
      height: 28px;
    }

    .player-olympic-player-next {
      width: 24px;
      height: 28px;
    }

    .prism-volume {
      margin-top: 14px !important;
      margin-right: 12px !important;
    }

    .prism-player .prism-volume .volume-icon {
      width: 27px;
      height: 26px;
      background-repeat: no-repeat;

      .short-horizontal {
        width: 2px;
        height: 7px;
      }

      .long-horizontal {
        width: 2px;
        height: 13px;
      }

      &.mute {
        .short-horizontal {
          height: 13px;
          top: 7px;
        }

        .long-horizontal {
          top: 7px;
          height: 13px;
        }
      }
    }

    .prism-player .prism-cc-btn {
      height: 24px;
      width: 20px;
      margin-top: 14px !important;
      margin-right: 22px !important;
    }

    .prism-player .prism-setting-btn {
      width: 20px;
      height: 22px;
      margin-top: 15px !important;
      margin-right: 23px !important;
    }

    .prism-time-display {
      margin-top: 4px !important;
      margin-left: 20px !important;
    }
  }
}

.detail {
  box-sizing: border-box;
  width: 1180px;
  margin: 20px auto 0;
  background: #0a2b51;
  border-radius: 20px;
  border: 1px solid #046bde;
  color: #fff;
  padding: 30px;
}

.tabs {
  display: flex;
}

.tab-item {
  position: relative;
  margin-right: 30px;
  font-weight: 600;
  font-size: 20px;
  cursor: pointer;

  &.on::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    bottom: -10px;
    width: 50px;
    height: 4px;
    margin: auto;
    background: #ffffff;
    border-radius: 2px;
  }
}

::v-deep.content {
  min-height: 150px;
  margin-top: 30px;

  &-intro {
    white-space: pre-wrap;

    img {
      vertical-align: top;
      max-width: 100%;
      height: auto;
    }
  }
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.bg-black {
  height: 435px;
  background: #000;
  font-size: 18px;
  font-weight: 700;
}

.intro {
  display: inline-block;
  max-width: 650px;
  padding: 13px 20px;
  background-color: #e6f2ff;
  border-radius: 4px;
  color: #046bde;
}

::v-deep .el-loading-mask {
  background-color: transparent !important;
}
</style>
